<template>
  <div>
    <!-- 搜索栏 + 按钮 -->
    <div style="display: flex; gap: 10px; margin-bottom: 15px;">
      <el-input
        v-model="keyword"
        placeholder="请输入小红盟关键词"
        @keyup.enter.native="handleSearch"
        clearable
      ></el-input>
      <el-button
        type="primary"
        @click="handleSearch"
      >搜索</el-button>
    </div>
    <div style="height: 700px; overflow: auto;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
      <el-table
        :data="tableData"
        v-loading="loading"
        style="width: 100%"
        border
      >
        <el-table-column
          prop="taskName"
          label="任务名称"
        >
        </el-table-column>
        <el-table-column
          prop="taskStartTime"
          label="任务开始时间"
        >
        </el-table-column>
        <el-table-column
          prop="taskEndTime"
          label="任务结束时间"
        >
        </el-table-column>

        <el-table-column
          prop="phone"
          label="联系电话"
        >
        </el-table-column>
        <el-table-column
          prop="taskState.msg"
          label="状态"
        >
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="380"
        >
          <template slot-scope="scope">
            <template v-if="scope.row.taskState.msg !== '未开始'">
              <span
                class="handel"
                @click="getXhmStat(scope.row)"
              >查看详情</span>
            </template>
          </template>
        </el-table-column>
      </el-table>

    </div>
  </div>
</template>
<script>
import { getV2Xhm } from "@/api/xhm";
import router from "@/router";
export default {
  data() {
    return {
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      keyword: "",
      loading: false
    };
  },
  mounted() {
    this.search();
  },
  methods: {
    handleSearch() {
      // 核心修复：搜索时强制回到第 1 页
      this.currentPage = 1;
      this.search();
    },
    async search(val) {
      this.loading = true;
      await getV2Xhm({
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        taskIdOrName: this.keyword
      }).then(res => {
        this.loading = false;
        if (res.code == 1000) {
          this.tableData = res.data.content.data;
          this.total = res.data.content.total;
        } else {
          this.$message({
            message: res.msg,
            type: "warning"
          });
        }
      });
    },
    searchActivity() {
      this.filteredData = this.tableData.filter(item =>
        item.name.includes(this.keyword)
      );
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search(); // 重新搜索以更新分页数据
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search(); // 重新搜索以更新分页数据
    },
    getXhmStat(val) {
      let routeData = router.resolve({
        name: `灵感小红盟每日数据（新）`,
        query: {
          taskId: val.taskId,
          taskName: val.taskName
        }
      });
      window.open(routeData.href, "_blank");
    }
  }
};
</script>